/**
 * ./src/exercise1/Exercise1Finish.js
 * 
 * This module handles the **completion process for Exercise 1**. It allows users to:
 * - **Rate the difficulty** of the exercise (1-5).
 * - **Rate the effectiveness** of the exercise (1-5).
 * - **Track user progress**, saving the time spent and highest time recorded.
 * - **Store user ratings** in Firebase for progress tracking.
 * 
 */

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { trackExercise } from '../firebase/exerciseTracker';
import './Exercise1Finish.css';
import Curtain from '../components/Curtain';
import Star1 from '../components/icons/star1.svg';
import Star2 from '../components/icons/star2.svg';
import TrueIcon from '../exercise1/icons/True.svg';
import FalseIcon from '../exercise1/icons/False.svg';
import { updateUserProgress } from '../utility';


const Exercise1Finish = () => {
  const [isCurtainActive, setIsCurtainActive] = useState(true); // animated curtain 
  const [currentStep, setCurrentStep] = useState(1);
  const [ratings, setRatings] = useState({ ease: null, effectiveness: null });
  const [debugInfo, setDebugInfo] = useState({ currentTime: 0 });
  const navigate = useNavigate();
  const location = useLocation();
  const timeSpent = location.state?.timeSpent || 0;
  const duration = location.state.duration || 1; // Get duration from navigation state

  const handleNextSection = () => {
    navigate("/exercise1summary", {
      state: {
        duration: duration
      },
    }); 
  };

  useEffect(() => {
    console.log(duration)
    const timeSpentMinutes = Math.round(timeSpent / 60);
    localStorage.setItem('exercise1CompletionTime', timeSpentMinutes.toString());

    const highestTime = parseInt(localStorage.getItem('exercise1HighestTime') || '0');
    if (timeSpentMinutes > highestTime) {
      localStorage.setItem('exercise1HighestTime', timeSpentMinutes.toString());
    }

    setDebugInfo({
      currentTime: timeSpentMinutes,
      highestTime: highestTime
    });

    const curtainTimer = setTimeout(() => {
      setIsCurtainActive(false);
    }, 2000);

    const welcomeTimer = setTimeout(() => {
      setCurrentStep(2);
    }, 3000);

    return () => {
      clearTimeout(curtainTimer);
      clearTimeout(welcomeTimer);
    };
  }, [timeSpent]);

  const handleRating = async (rating) => {
    if (currentStep === 2) {
      const durations = [1, 3, 5, 8, 10];
      if (rating === 5) {
        updateUserProgress(1, duration, 0);
        console.log(durations.indexOf(duration) === durations.length - 1)
        if (durations.indexOf(duration) === durations.length - 1){
          navigate('/exercise1fullycomplete');
        }
      }
      else if (rating === 1){
        navigate('/exercise1failed');
      }
      setRatings(prev => ({ ...prev, ease: rating }));
      setCurrentStep(3);
    } else if (currentStep === 3) {
      const finalRatings = {
        ease: ratings.ease,
        effectiveness: rating
      };

      try {

        const timeSpentMinutes = Math.round(timeSpent / 60);
        const highestTime = parseInt(localStorage.getItem('exercise1HighestTime') || '0');
        
        setDebugInfo({
          currentTime: timeSpentMinutes,
          highestTime: highestTime
        });
        


        navigate('/exercise1summary', {
          state: {
            currentTime: timeSpentMinutes,
            highestTime: highestTime
          }
        });
      } catch (error) {
        console.error('Error tracking exercise:', error);
      }
    }
  };

  const renderContent = () => {
    return (
      <>
        {/* <div style={{ position: 'fixed', bottom: 10, left: 10, background: 'rgba(0,0,0,0.7)', color: 'white', padding: '5px', borderRadius: '3px', fontSize: '12px' }}>
          Current Time: {debugInfo.currentTime}min<br/>
          Highest Time: {debugInfo.highestTime}min
        </div> */}

        {currentStep === 1 && (
          <div className="welcome-container">
            <div className="message-bubble"> Hi, I'm Sunny! Just checking in. </div>
            <img src={Star1} alt="" className="star" />          
          </div>
        )}
        {currentStep === 2 && (
          <div className="rating-container">
            <div className="message-bubble">Is your breathing steady for more than 95% of the time?</div>
            <img src={Star2} alt="" className="star" />
            <div className="rating-section">
              <div className="button-column">
                <button onClick={() => handleRating(1)} className="rating-button button-false"> <img src={FalseIcon} alt="No" className="false-icon" /> </button>
                <div className="label">No</div>
              </div>

              <div className="button-column">
                <button onClick={() => handleRating(5)} className="rating-button button-true"> <img src={TrueIcon} alt="Yes" className="true-icon" /> </button>
                <div className="label">Yes</div>
              </div>
            </div>
          </div>
        )}
        {currentStep === 3 && (
        <>
          <div className="rating-container">
            <div className="message-bubble">
              Breathing comfortably is essential for future exercises. Find your own Breathing rhythm.
            </div>
            <img src={Star2} alt="" className="star" />
          </div>
          {/* Move button outside of .rating-container */}
          <div className="bottom">
            <button className="next-button" onClick={handleNextSection}> Next </button>
          </div>
        </>
      )}
      </>
    );
  };

  return (
    <div className="exercise-finish-container">
      {isCurtainActive && <Curtain disappear={true} duration={2000} />}
      {renderContent()}
    </div>
  );
};

export default Exercise1Finish;